import React, { useState } from 'react';
import config from '../../utils/config';
import { useAuth } from '../../utils/AuthContext/AuthContext';

const AddProfessionalForm = ({ onSubmit }) => {
  const { token, user } = useAuth();
  const [professionalFormData, setProfessionalFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    profession: '',
    charge: {
      chargeType: '',
      chargeFee: ''
    },
    contact: {
      email: '',
      phone: '',
      address: ''
    },
    about: '',
    experience: {
      jobsCompleted: '',
      yearsInService: ''
    },
    googlePlaceId: '',
    imageUrl: '',
    reviewData: {
      overallRating: 0,
      totalReviews: 0,
      // reviews: [{
      //   author_name: '',
      //   rating: 0,
      //   text: '',
      //   relative_time_description: '',
      //   time: 0,
      // }]
    }
  });

  const [googlePlaceId, setGooglePlaceId] = useState('');
  const [fetchingReviews, setFetchingReviews] = useState(false);

  const professions = [
    'Inspector',
    'Attorney', 
    'Lender', 
    'Insurance', 
    'Mover', 
    'Handyman', 
    'Surveyor',
  ];

  const chargeTypes = [
    '/ hour',
    'fixed',
    'annual', 
    '/ job', 
  ]

  const handleChange = (e) => {
    const { name, value } = e.target;
    const keys = name.split('.');
    if (keys.length > 1) {
      setProfessionalFormData(prevState => {
        let updatedData = { ...prevState };
        let nestedData = updatedData;
        for (let i = 0; i < keys.length - 1; i++) {
          nestedData = nestedData[keys[i]];
        }
        nestedData[keys[keys.length - 1]] = value;
        return updatedData;
      });
    } else {
      setProfessionalFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(professionalFormData);
  };

  const handleFetchReviews = async () => {
    setFetchingReviews(true);
    try {
      const response = await fetch(`${config.apiBaseUrl}/fetch-reviews`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ googlePlaceId })
      });
      const data = await response.json();
      console.log(data.message);
    } catch (error) {
      console.error('Error fetching reviews:', error);
    } finally {
      setFetchingReviews(false);
    }
  };

  return (
    
    <form onSubmit={handleSubmit} className='flex flex-col gap-2 px-4 mt-4 w-[50vw]'>
      <input type="text" name="firstName" placeholder="First Name" value={professionalFormData.firstName} onChange={handleChange} required />
      <input type="text" name="lastName" placeholder="Last Name" value={professionalFormData.lastName} onChange={handleChange} required />
      <input type="text" name="companyName" placeholder="Company Name" value={professionalFormData.companyName} onChange={handleChange} required />
      <select name="profession" value={professionalFormData.profession} onChange={handleChange} required>
        <option value="" disabled>Select Profession</option>
        {professions.map((profession, index) => (
          <option key={index} value={profession}>
            {profession}
          </option>
        ))}
      </select>
      <select name="charge.chargeType" value={professionalFormData.charge.chargeType} onChange={handleChange} required>
        <option value="" disabled>Select Charge Type</option>
        {chargeTypes.map((chargeType, index) => (
          <option key={index} value={chargeType}>
            {chargeType}
          </option>
        ))}
      </select>
      {/* <input type="text" name="charge.chargeType" placeholder="Charge Type" value={professionalFormData.charge.chargeType} onChange={handleChange} required /> */}
      <input type="number" name="charge.chargeFee" placeholder="Charge Fee" value={professionalFormData.charge.chargeFee} onChange={handleChange} required />
      <input type="email" name="contact.email" placeholder="Email" value={professionalFormData.contact.email} onChange={handleChange} required />
      <input type="text" name="contact.phone" placeholder="Phone" value={professionalFormData.contact.phone} onChange={handleChange} required />
      <input type="text" name="contact.address" placeholder="Address" value={professionalFormData.contact.address} onChange={handleChange} required />
      <textarea name="about" placeholder="About" value={professionalFormData.about} onChange={handleChange} required />
      <input type="text" name="experience.jobsCompleted" placeholder="Jobs Completed" value={professionalFormData.experience.jobsCompleted} onChange={handleChange} required />
      <input type="text" name="experience.yearsInService" placeholder="Years in Service" value={professionalFormData.experience.yearsInService} onChange={handleChange} required />
      <input type="text" name="googlePlaceId" placeholder="Google Place ID" value={professionalFormData.googlePlaceId} onChange={handleChange} />
      <input type="number" name="reviewData.overallRating" placeholder="Overall Rating" value={professionalFormData.reviewData.overallRating} onChange={handleChange} />
      <input type="number" name="reviewData.totalReviews" placeholder="Total Reviews" value={professionalFormData.reviewData.totalReviews} onChange={handleChange} />
      <input type="text" name="imageUrl" placeholder="Image URL" value={professionalFormData.imageUrl} onChange={handleChange} />
      <button type="submit">Add Professional</button>

            {/* Section for Admin to input Google Place ID and fetch reviews */}
        <div className="mt-4">
        <h3>Admin: Fetch Google Reviews</h3>
        <input
          type="text"
          placeholder="Google Place ID"
          className='mr-2'
          value={googlePlaceId}
          onChange={(e) => setGooglePlaceId(e.target.value)}
        />
        <button
          type="button"
          className='border border-black px-2 py-1'
          onClick={handleFetchReviews}
          disabled={fetchingReviews}
        >
          {fetchingReviews ? 'Fetching...' : 'Fetch and Post Reviews'}
        </button>
      </div>
    </form>
  );
  
};

export default AddProfessionalForm;